import { Component, Input } from '@angular/core';
import { AccountServiceProvider } from '@services/user/account.service';
import { User } from '@models/models';

@Component({
	selector: 'user-menu',
	template: require('./user-menu.html')
})
export class UserMenuComponent {
	@Input() user: User;
	constructor(private accountService: AccountServiceProvider) {}

	logout(): void {
		this.accountService.logoutWeb();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/user-menu/user-menu.ts